/**
 * Offline cache constants for the learner MFE.
 */

/** IndexedDB database name. */
export const IDB_NAME = "aster-offline";

/** IndexedDB schema version. Bump when stores change. */
export const IDB_VERSION = 3;

/** Object store for GraphQL query payloads. */
export const STORE_GQL = "gql";

/** Object store reserved for deferred writes (progress, quiz answers, uploads). */
export const STORE_SYNC = "syncQueue";

/** Object store for the last route plus in-progress app state. */
export const STORE_SESSION = "session";

/** Primary key for the single working-session record. */
export const SESSION_RECORD_KEY = "current";

/** sessionStorage key for the last in-app path (survives refresh in this tab). */
export const LAST_PATH_KEY = "aster-last-path";

/** localStorage prefix for GraphQL jobs that must survive a refresh if IndexedDB aborts. */
export const QUEUE_BACKUP_PREFIX = "aster-sync-queue-gql:";

/** localStorage key for in-progress module time that has not been queued yet. */
export const PENDING_INSPECT_KEY = "aster-pending-inspect";

/**
 * GraphQL operation names that are safe to persist and replay offline.
 * Mutations are excluded; write-like queries are queued instead of cached.
 */
export const CACHEABLE_OPERATIONS = new Set([
  "app_dashboard_get",
  "app_course_detail_get",
  "app_course_unit_get",
  "app_first_load_get",
  "comment_list",
  "chat_list",
  "user_login_log_list",
  "user_chart_list",
  "inspect_module_list",
  "inspect_meeting_list",
  "inspect_replay_list",
  "meet_recording_list",
  "admin_user_report_get",
]);

/**
 * Named queries that perform writes and must be flushed when the network returns.
 */
export const QUEUEABLE_QUERY_OPERATIONS = new Set(["send_survey_email", "send_coach_email"]);
